<template>
	<v-layout column>
		<v-card-text>
			<div>
				<v-card-title>
					<h2>Formularze wniosku</h2>
				</v-card-title>
			</div>
			<v-layout row mb-3>
				<v-flex xs6>
					<agency-contest-form-item
						:disabled="contestData.open"
						v-bind:form-defined="formStatus.contestFormDefined"
						v-bind:checkbox="offerCheckbox"
						v-on:form-deleted="formDeleted" v-on:form-chosen="formChosen"></agency-contest-form-item>
				</v-flex>
			</v-layout>
			<div>
				<v-card-title>
					<h2>Formularze ocen i opinii</h2>
				</v-card-title>
			</div>
			<v-layout row>
				<v-flex xs6>
					<agency-contest-form-item
						:disabled="evaluationsNotEditable"
						v-bind:form-defined="formStatus.individualEvaluationFormDefined"
						v-bind:checkbox="individualEvaluationCheckbox"
						v-on:form-deleted="formDeleted" v-on:form-chosen="formChosen"></agency-contest-form-item>
				</v-flex>
				<v-flex xs6>
					<agency-contest-form-item
						:disabled="evaluationsNotEditable"
						v-bind:form-defined="formStatus.expertEvaluationFormDefined"
						v-bind:checkbox="expertEvaluationCheckbox"
						v-on:form-deleted="formDeleted" v-on:form-chosen="formChosen"></agency-contest-form-item>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs6>
					<agency-contest-form-item
						:disabled="evaluationsNotEditable"
						v-bind:form-defined="formStatus.finalEvaluationFormDefined"
						v-bind:checkbox="finalEvaluationCheckbox"
						v-on:form-deleted="formDeleted" v-on:form-chosen="formChosen"></agency-contest-form-item>
				</v-flex>
			</v-layout>

			<v-divider/>
			<div>
				<v-card-title>
					<h2>Formularze raportów</h2>
					<v-spacer></v-spacer>
				</v-card-title>
			</div>
			<v-layout row>
				<v-flex xs6>
					<agency-contest-form-item
						v-bind:form-defined="formStatus.monitoringReportFormDefined"
						v-bind:checkbox="monitoringReportCheckbox"
						v-on:form-deleted="formDeleted" v-on:form-chosen="formChosen"></agency-contest-form-item>
				</v-flex>
			</v-layout>


			<v-divider/>
			<div>
				<v-card-title>
					<h2>Sprawozdanie końcowe</h2>
				</v-card-title>
			</div>
			<v-layout row>
				<v-flex xs6>
					<agency-contest-form-item
						v-bind:form-defined="formStatus.finalReportFormDefined"
						v-bind:checkbox="finalReportCheckbox"
						v-on:form-deleted="formDeleted" v-on:form-chosen="formChosen"></agency-contest-form-item>
				</v-flex>
			</v-layout>
		</v-card-text>
	</v-layout>
</template>

<script>
	import {Api} from "../../../../api";
	import AgencyContestFormItem from "./AgencyContestFormItem";
	import {AgencyContest} from "../../../../api/generated/AgencyContest";

	export default {
		name: "ContestOfferFormPanel",
		components: {AgencyContestFormItem},

		data() {
			return {
				formStatus: {
					contestFormDefined: false,
					individualEvaluationFormDefined: false,
					expertEvaluationFormDefined: false,
					finalEvaluationFormDefined: false,
					finalReportFormDefined: false,
					monitoringReportFormDefined: false,
				},

				offerCheckbox: {
					status: true,
					isDisabled: true,
					text: "Formularz wniosku",
					formType: "OFFER",
				},

				finalEvaluationCheckbox: {
					status: false,
					isDisabled: false,
					text: "Opinia końcowa",
					formType: "FINAL_EVALUATION",
				},

				individualEvaluationCheckbox: {
					status: false,
					isDisabled: false,
					text: "Indywidualna opinia członka zespołu",
					formType: "INDIVIDUAL_EVALUATION",
				},

				expertEvaluationCheckbox: {
					status: false,
					isDisabled: false,
					text: "Opinia eksperta",
					formType: "EXPERT_EVALUATION",
				},

				monitoringReportCheckbox: {
					status: false,
					isDisabled: false,
					text: "Raporty z monitoringu",
					formType: "MONITORING_REPORT",
				},

				finalReportCheckbox: {
					status: false,
					isDisabled: false,
					text: "Sprawozdanie końcowe",
					formType: "FINAL_REPORT",
				},

				contestData: {
					id: this.$route.params.id,
					open: undefined,
					evaluationOpen: undefined,
					evaluationFinished: undefined,
				},
			};
		},

		computed: {
			evaluationsNotEditable() {
				return this.contestData.evaluationOpen || this.contestData.evaluationFinished;
			},
		},

		methods: {
			setFormStatus(response) {
				this.formStatus.contestFormDefined = response.agencyContestSchemaSet.offerSchema !== null;
				this.formStatus.individualEvaluationFormDefined = response.agencyContestSchemaSet.individualEvaluationSchema !== null;
				this.formStatus.expertEvaluationFormDefined = response.agencyContestSchemaSet.expertEvaluationSchema !== null;
				this.formStatus.finalEvaluationFormDefined = response.agencyContestSchemaSet.finalEvaluationSchema !== null;
				this.formStatus.monitoringReportFormDefined = response.agencyContestSchemaSet.monitoringReportSchema !== null;
				this.formStatus.finalReportFormDefined = response.agencyContestSchemaSet.finalReportSchema !== null;

				this.finalEvaluationCheckbox.status = response.agencyContestSchemaSet.finalEvaluationSchemaIncluded;
				this.individualEvaluationCheckbox.status = response.agencyContestSchemaSet.individualEvaluationSchemaIncluded;
				this.expertEvaluationCheckbox.status = response.agencyContestSchemaSet.expertEvaluationSchemaIncluded;
				this.monitoringReportCheckbox.status = response.agencyContestSchemaSet.monitoringReportSchemaIncluded;
				this.finalReportCheckbox.status = response.agencyContestSchemaSet.finalReportSchemaIncluded;
			},

			formDeleted() {
				this.$emit("form-deleted");
			},

			formChosen() {
				this.$emit("form-chosen");
			},
		},

		mounted() {
			Api.getWithParam(this, "/agency-contest/all-forms", {contestId: this.$route.params.id}, response => {
				this.setFormStatus(response);
			});

			AgencyContest.getState(this, this.contestData.id, response => {
				this.contestData.open = response.agencyContestAnnouncementStatus === "ANNOUNCED";
				this.contestData.evaluationOpen = response.agencyContestStatus === "STARTED";
				this.contestData.evaluationFinished = response.agencyContestStatus === "FINISHED";
			});
		},
	};
</script>

<style scoped>

</style>
